import {objectsAttributes} from "../../models/objects";
import PoolIcon from "../../data/Icons/leon-inmobiliaria-icons-pool.svg";
import TVIcon from "../../data/Icons/leon-inmobiliaria-icons-tv.svg";
import DishwasherIcon from "../../data/Icons/leon-inmobiliaria-icons-spuelmaschine.svg";
import GrillIcon from "../../data/Icons/leon-inmobiliaria-icons-grill.svg";
import LivingAreaIcon from "../../data/Icons/leon-inmobiliaria-icons-wohnflaeche.svg";
import IconPlotSize from "../../data/Icons/leon-inmobiliaria-icons-grundstueck.svg";
import BootsliegeplatzIcon from "../../data/Icons/leon-inmobiliaria-icons-bootsanlegeplatz.svg";
import AirConditioning from "../../data/Icons/leon-inmobiliaria-icons-klimaanlage.svg";
import WaschmaschineIcon from "../../data/Icons/leon-inmobiliaria-icons-waschmaschine.svg";
import InternetIcon from "../../data/Icons/leon-inmobiliaria-icons-wlan.svg";
import ClosedIcon from "../../data/Icons/leon-inmobiliaria-icons-geschlossen.svg";
import RolladenIcon from "../../data/Icons/leon-inmobiliaria-icons-rollladen.svg";
import GarageIcon from "../../data/Icons/leon-inmobiliaria-icons-garage.svg";
import PetsIcon from "../../data/Icons/leon-inmobiliaria-icons-hund.svg";
import {season_dates} from "../../models/season_dates";
import {TFunction} from "next-i18next";
import {booking} from "../../models/booking";

export function getBookedDates(
	filtedBookingsByObjectId: booking[] | undefined
) {
	return filtedBookingsByObjectId
		?.sort(
			(a, b) =>
				new Date(a.from_date * 1000).getTime() - new Date(b.from_date * 1000).getTime()
		).filter((v) => {
			//console.log(new Date(v.from_date*1000),new Date(v.to_date*1000));
			return v.to_date > v.from_date
		})
		.reduce((prevBookings, curBooking) => {
			let startDate = new Date(curBooking.from_date * 1000);
			const startDatePlusOne = (curBooking.from_date + 24 * 60 * 60) * 1000;
			const endDate = (curBooking.to_date - 24 * 60 * 60) * 1000;
			if (prevBookings.length > 0) {
				if (
					prevBookings[prevBookings.length - 1].end.getTime() +
					24 * 60 * 60 * 1000 <
					startDate.getTime()
					&& startDatePlusOne < endDate
				) {
					startDate = new Date(startDatePlusOne);
				}
			} else if (startDatePlusOne < endDate) {
				startDate = new Date((curBooking.from_date + 24 * 60 * 60) * 1000);
			}
			return [
				...prevBookings,
				{
					start: startDate,
					end: new Date(endDate)
				}
			];
		}, [] as { start: Date; end: Date }[]);
}

export function calcTotalStayInDays(startDate: Date, endDate: Date) {
	const totalStayInDays =
		Math.floor((endDate?.getTime()! - startDate?.getTime()!) / (1000 * 60 * 60 * 24));

	return totalStayInDays;
}

export function calcVerbindlicheLeistungenObject(
	object: objectsAttributes,
	totalStayInDays: number,
	adultsCount: number,
	t: TFunction,
	fromDate: Date,
	toDate: Date
) {
	let verbindlicheLeistungenObject: {
		text: string;
		subTitle?: string;
		price: number;
	}[] = [];

	if (parseInt(object.end_cleaning) > 0) {
		verbindlicheLeistungenObject.push({
			text: t("components.calcHelpers.verbindlicheLeistungen.endCleaning"),
			price: parseInt(object.end_cleaning)
		});
	}

	if (parseInt(object.deposit) > 0) {
		verbindlicheLeistungenObject.push({
			text: t("components.calcHelpers.verbindlicheLeistungen.deposit.title"),
			subTitle: t(
				"components.calcHelpers.verbindlicheLeistungen.deposit.subtitle"
			),
			price: parseInt(object.deposit)
		});
	}

	if (adultsCount > 0 && totalStayInDays > 0) {
		// TODO: Why is kurtaxe in database if it is always 1?
		const kurtaxe = 1.75;
		verbindlicheLeistungenObject.push({
			text: t("components.calcHelpers.verbindlicheLeistungen.tax"),
			subTitle: "",
			price: adultsCount * (totalStayInDays > 7 ? 7 : totalStayInDays) * kurtaxe
		});
	}

	if (object.poolheating_price_in_eur > 0) {
		let daysPerMonth = [];

		for (let index = 0; index < 11; index++) {
			daysPerMonth.push({month: index + 1, daysBooked: 0});
		}

		for (
			let index = new Date(fromDate);
			index.getTime() < toDate.getTime();
			index.setDate(index.getDate() + 1)
		) {
			const newDaysBooked = daysPerMonth[index.getMonth()].daysBooked + 1;
			daysPerMonth[index.getMonth()].daysBooked = newDaysBooked;
		}
		let poolObject: any = {
			text: t("components.calcHelpers.verbindlicheLeistungen.poolHeating")
		};
		let poolHeatingPrice = 0;
		daysPerMonth.forEach((month) => {
			let newPoolHeatingPrice = poolHeatingPrice;
			/* if (
			  month.month >= object.poolheating_billing_from_month ||
			  month.month <= object.poolheating_billing_to_month
			) { */
			for (let index = 0; index < month.daysBooked; index++) {
				newPoolHeatingPrice =
					newPoolHeatingPrice + object.poolheating_price_in_eur / 7;
			}
			//}
			poolHeatingPrice = newPoolHeatingPrice;
		});
		if (object.poolheating_billing_type === 2 && poolHeatingPrice != 0) {
			poolObject = {
				...poolObject,
				price: Math.ceil(poolHeatingPrice),
				subTitle: t("components.calcHelpers.verbindlicheLeistungen.perWeek")
			};
		}
		if (object.poolheating_billing_type === 1) {
			poolObject = {
				...poolObject,
				price: object.poolheating_price_in_eur,
				subTitle: t("components.calcHelpers.verbindlicheLeistungen.flatrate")
			};
		}
		if (poolObject.price) {
			verbindlicheLeistungenObject.push(poolObject);
		}
	}

	if (object.aircondition_price_in_eur > 0) {
		let airconditionObject: any = {
			text: t("components.calcHelpers.verbindlicheLeistungen.airCondition")
		};
		if (object.aircondition_price_in_eur === 2) {
			airconditionObject = {
				...airconditionObject,
				price: (object.aircondition_price_in_eur / 7) * totalStayInDays,
				subTitle: t("components.calcHelpers.verbindlicheLeistungen.perWeek")
			};
		}
		if (object.aircondition_price_in_eur === 1) {
			airconditionObject = {
				...airconditionObject,
				price: object.aircondition_price_in_eur,
				subTitle: t("components.calcHelpers.verbindlicheLeistungen.flatrate")
			};
		}
		verbindlicheLeistungenObject.push(airconditionObject);
	}

	if (object.heating_price_in_eur > 0) {
		let heatingObject: any = {
			text: t("components.calcHelpers.verbindlicheLeistungen.heating")
		};
		if (object.heating_price_in_eur === 2) {
			heatingObject = {
				...heatingObject,
				price: (object.heating_price_in_eur / 7) * totalStayInDays,
				subTitle: t("components.calcHelpers.verbindlicheLeistungen.perWeek")
			};
		}
		if (object.heating_price_in_eur === 1) {
			heatingObject = {
				...heatingObject,
				price: object.heating_price_in_eur,
				subTitle: t("components.calcHelpers.verbindlicheLeistungen.flatrate")
			};
		}
		verbindlicheLeistungenObject.push(heatingObject);
	}

	const verbindlicheLeistungenEndPrice = verbindlicheLeistungenObject
		.filter(
			(item) =>
				item.text !==
				t("components.calcHelpers.verbindlicheLeistungen.deposit.title") &&
				item.text !==
				t("components.calcHelpers.verbindlicheLeistungen.poolHeating")
		)
		.map((item) => item.price)
		.reduce((a, b) => a + b);

	return [verbindlicheLeistungenObject, verbindlicheLeistungenEndPrice];
}

export function calcZuZahlenBeiBuchungUndAnkunft(gesamtPreis: number) {
	const zuZahlenBeiBuchungPreis = Math.round((gesamtPreis * 0.3) / 50) * 50;
	const zuZahlenBeiAnkunftPreis = gesamtPreis - zuZahlenBeiBuchungPreis;
	return [zuZahlenBeiBuchungPreis, zuZahlenBeiAnkunftPreis];
}

export function calcIconGallery(object: objectsAttributes, t: TFunction) {
	let iconGallery: {
		icon: JSX.Element;
		name: string;
	}[] = [];

	if (object.internet === 1) {
		iconGallery.push({
			icon: <InternetIcon/>,
			name: "filter.internet"
		});
	}
	if (
		object.outdoor_pool === 1 ||
		object.indoor_pool === 1 ||
		object.private_pool === 1 ||
		object.communal_pool === 1
	) {
		iconGallery.push({
			icon: <PoolIcon/>,
			name: "filter.pool"
		});
	}
	if (object.dishwasher === 1) {
		iconGallery.push({
			icon: <DishwasherIcon/>,
			name: "filter.dishwasher"
		});
	}
	if (object.cable_sat_tv === 1) {
		iconGallery.push({
			icon: <TVIcon/>,
			name: "filter.satTv"
		});
	}
	if (object.bbq_grill === 1) {
		iconGallery.push({
			icon: <GrillIcon/>,
			name: "filter.bbqGrill"
		});
	}
	if (object.aircondition >= 1) {
		iconGallery.push({
			icon: <AirConditioning/>,
			name: "filter.airCondition"
		});
	}
	if (object.washing_machine === 1) {
		iconGallery.push({
			icon: <WaschmaschineIcon/>,
			name: "filter.washingMachine"
		});
	}
	if (object.garage >= 1) {
		iconGallery.push({
			icon: <GarageIcon/>,
			name: "filter.garage"
		});
	}
	// if (object.parking > 0) {
	//   // TODO.QUESTION: How is parking actually defined?
	//   iconGallery.push({
	//     icon: <ParkplatzIcon />,
	//     name: "Parkplatz"
	//   });
	// }
	if (object.living_area_m2 > 0) {
		iconGallery.push({
			icon: <LivingAreaIcon/>,
			name: `${t("circa")} ${object.living_area_m2} \u33A1`
		});
	}
	if (object.fenced_yard === 1) {
		iconGallery.push({
			icon: <ClosedIcon/>,
			name: "filter.fencedYard"
		});
	}
	if (object.shutters === 1) {
		iconGallery.push({
			icon: <RolladenIcon/>,
			name: "filter.shutters"
		});
	}
	if (object.plot_size > 0) {
		iconGallery.push({
			icon: <IconPlotSize/>,
			name: `${t("circa")} ${object.plot_size} \u33A1`
		});
	}
	// if (object.pool_heating_system === 1) {
	//   // TODO: Add real Icon (missing)
	//   iconGallery.push({
	//     icon: <InternetIcon />,
	//     name: "Poolheizung"
	//   });
	// }
	if (object.mooring === 1) {
		iconGallery.push({
			icon: <BootsliegeplatzIcon/>,
			name: "filter.mooring"
		});
	}
	if (object.pets === 1) {
		iconGallery.push({
			icon: <PetsIcon/>,
			name: "filter.pets"
		});
	}
	// if (object.kitchen > 0) {
	//   // TODO: Add real Icon (missing)
	//   if (object.kitchen === 1) {
	//     iconGallery.push({
	//       icon: <InternetIcon />,
	//       name: "Basic"
	//     });
	//   } else if (object.kitchen === 2) {
	//     iconGallery.push({
	//       icon: <InternetIcon />,
	//       name: "Full"
	//     });
	//   } else if (object.kitchen === 3) {
	//     iconGallery.push({
	//       icon: <InternetIcon />,
	//       name: "American Basic"
	//     });
	//   } else if (object.kitchen === 4) {
	//     iconGallery.push({
	//       icon: <InternetIcon />,
	//       name: "American Full"
	//     });
	//   }
	// }
	// if (object.heating_type > 0) {
	//   // TODO: Add real Icon (missing)
	//   if (object.heating_type === 1) {
	//     iconGallery.push({
	//       icon: <InternetIcon />,
	//       name: "Öl"
	//     });
	//   } else if (object.heating_type === 2) {
	//     iconGallery.push({
	//       icon: <InternetIcon />,
	//       name: "Gas"
	//     });
	//   } else if (object.heating_type === 3) {
	//     iconGallery.push({
	//       icon: <InternetIcon />,
	//       name: "Elektrisch"
	//     });
	//   } else if (object.heating_type === 4) {
	//     iconGallery.push({
	//       icon: <InternetIcon />,
	//       name: "Wärmepumpe"
	//     });
	//   }
	// }
	// if (object.microwave === 1) {
	//   // TODO: Add real Icon (missing)
	//   iconGallery.push({
	//     icon: <InternetIcon />,
	//     name: "Mikrowelle"
	//   });
	// }

	return iconGallery;
}

export function calcPersonSleepingBathrooms(object: objectsAttributes) {
	let personSleepingBathrooms: {
		persons: number;
		bedrooms: number;
		bathrooms: number;
	} = {
		persons: 0,
		bedrooms: 0,
		bathrooms: 0
	};
	if (!object)
		return {
			persons: 1,
			bedrooms: 1,
			bathrooms: 1
		};

	if (object.persons_total > 0) {
		personSleepingBathrooms.persons = object.persons_total;
	}
	if (object.bedrooms_total > 0) {
		personSleepingBathrooms.bedrooms = object.bedrooms_total;
	}
	if (object.bathrooms_total > 0) {
		personSleepingBathrooms.bathrooms = object.bathrooms_total;
	}
	return personSleepingBathrooms;
}

export const getDaysArray = (start: Date, end: Date) => {
	for (
		var arr = [], dt = new Date(start);
		dt <= end;
		dt.setDate(dt.getDate() + 1)
	) {
		arr.push({date: new Date(dt.getTime() + 2 * 60 * 60 * 1000), season: 0});
	}
	return arr;
};

function getNormalPricePerDay(seasonNumber: number, object: objectsAttributes) {
	// default and fallback is seasonNumber === 3 (after season)
	let normalPricePerDay =
		object.as_in_eur_per_week > 0
			? object.as_in_eur_per_week / 7
			: object.as_in_eur_per_day;

	if (seasonNumber === 2) {
		normalPricePerDay = object.ms_in_eur_per_week / 7;
	}

	if (seasonNumber === 1) {
		normalPricePerDay =
			object.ls_in_eur_per_week > 0
				? object.ls_in_eur_per_week / 7
				: object.ls_in_eur_per_day;
	}

	//console.log("Normal price per day for season ", seasonNumber, normalPricePerDay)
	return normalPricePerDay;
}

export function convertDBDateToJSDate(dbDate: string) {
	const dateParts = dbDate.split("-");

	// Note that the month argument for the Date constructor is zero-based (0 = January)
	const jsDate = new Date(
		parseInt(dateParts[0]),
		parseInt(dateParts[1]) - 1,
		parseInt(dateParts[2])
	);
	return jsDate;
}

interface DayWithSeason {
	date: Date;
	season: number;
}

const debugPricing = false;

export function calcNormalRentPrice(
	object: objectsAttributes,
	seasonDates: season_dates[],
	_startDate?: Date | null,
	_endDate?: Date | null
) {
	// EXAMPLES:
	/**
	 * 08.09.2023 - 13.09.2023
	 *
	 * Special Price
	 * 08,09,10 -> special_price -> 315*3 = 945
	 * 11,12,13 -> low_season -> 1295/7*3 = 555
	 * gesamt = 1500 €
	 *
	 * Normal Price
	 * 08,09 -> main_season -> 2450/7*2 = 700
	 * 10,11,12,13 -> low_season -> 1295/7*4 = 740
	 * gesamt = 1440 €
	 *
	 * ##########################################
	 *
	 * 29.08.2023 - 06.09.2023
	 *
	 * Special Price
	 * 29,30,31,1,2 -> main_season -> 2450/7*5 = 1750
	 * 03,04,05,06 -> special_price -> 315*4 = 1260
	 * gesamt = 3010 €
	 *
	 * Normal Price
	 * 29,30,31,1,2,3,4,5,6 -> main_season -> 2450/7*9 = 3150
	 * gesamt = 3150 €
	 */

	const anyFallBackLowSeason = seasonDates.find(
		(seasonDate) => seasonDate.season === 3
	);
	const fallBackStartDate = anyFallBackLowSeason
		? new Date(anyFallBackLowSeason.from_date + 2 * 60 * 60)
		: new Date();
	const startDate = _startDate ?? fallBackStartDate;
	const endDate = new Date(_endDate ?? startDate);
	if (!_endDate) {
		endDate.setDate(startDate.getDate() + 6);
	} else {
		endDate.setDate(endDate.getDate() - 1);
	}
	/* console.log("Given start date", _startDate);
	console.log("Given end date", _endDate);
	console.log("Start date", startDate),
	console.log("End date", endDate); */
	const selectedDays: DayWithSeason[] = getDaysArray(startDate, endDate);

	const rentLastMinutePricePerDay = object.rent_special_price_eur_per_day;
	const rentLastMinutePriceFrom = object.rent_special_price_from;
	const rentLastMinutePriceTo = object.rent_special_price_to;

	if (debugPricing) {
		console.log("=======================");
		console.log("SELECTED DAYS", selectedDays);
		console.log("=======================");
	}
	// Add season information:
	selectedDays.map((day: DayWithSeason) => {
		const seasons = seasonDates?.filter((season: season_dates) => {
			const seasonStartDate = (season.from_date + 60 * 60 * 2) * 1000;
			const seasonEndDate = (season.to_date + 60 * 60 * 2) * 1000;
			const isDateInSeason =
				day.date.getTime() >= seasonStartDate &&
				day.date.getTime() <= seasonEndDate;
			if (isDateInSeason && debugPricing) {
				console.log(
					"Day is in season",
					season.season,
					day.date.toLocaleDateString(),
					new Date(seasonStartDate).toLocaleDateString(),
					new Date(seasonEndDate).toLocaleDateString()
				);
			}

			return isDateInSeason;
		});

		if (seasons.length > 0) {
			day.season = seasons[0].season;
		} else {
			if (debugPricing) {
				console.log("Day is in NO season", day.date.toLocaleDateString());
			}
		}
		return day;
	});

	if (debugPricing) {
		console.log("=======================");
		console.log("CALCULATE NORMAL PRICE FOR OBJECT ", object.object_id);
		console.log("=======================");
	}

	let _normalPrice = selectedDays.reduce((prev, cur) => {
		const tmpPrice = getNormalPricePerDay(cur.season, object);
		if (debugPricing)
			console.log(
				cur.date.toLocaleDateString(),
				"NORMAL PRICE FOR SEASON " + cur.season,
				tmpPrice
			);
		return prev + tmpPrice;
	}, 0);

	const calcSpecialPrice =
		rentLastMinutePricePerDay &&
		rentLastMinutePricePerDay > 0 &&
		rentLastMinutePriceFrom &&
		rentLastMinutePriceTo;
	let _specialPrice = 0;
	if (calcSpecialPrice) {
		if (debugPricing) {
			console.log("=======================");
			console.log("CALCULATE SPECIAL PRICE FOR OBJECT", object.object_id);
			console.log("=======================");
		}
		_specialPrice = selectedDays.reduce((prev, cur) => {
			let tmpPrice = getNormalPricePerDay(cur.season, object);
			if (
				cur.date.getTime() >= Date.parse(rentLastMinutePriceFrom) &&
				cur.date.getTime() <= Date.parse(rentLastMinutePriceTo)
			) {
				tmpPrice = rentLastMinutePricePerDay;
				if (debugPricing)
					console.log(
						cur.date.toLocaleDateString(),
						"LAST MINUTE PRICE",
						tmpPrice
					);
			} else {
				if (debugPricing)
					console.log(
						cur.date.toLocaleDateString(),
						"NORMAL PRICE FOR SEASON " + cur.season,
						tmpPrice
					);
			}
			return prev + tmpPrice;
		}, 0);
	}

	if (!_startDate && !_endDate && object.rent_special_price_eur_per_day) {
		_specialPrice = object.rent_special_price_eur_per_day * 7;
	}

	if (_normalPrice <= _specialPrice) {
		_specialPrice = 0;
	}

	return [_normalPrice, _specialPrice];
}
